import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Menu, MenuItem } from '@mui/material';
import { gridFilteredSortedRowIdsSelector, useGridApiContext } from '@mui/x-data-grid';
import React, { ReactNode, useState } from 'react';

export interface DownloadCsvAdditionalAction {
  label: string;
  icon?: ReactNode;
  onClick: () => void;
}

interface Props {
  additionalActions?: DownloadCsvAdditionalAction[];
  onDownloadCsv?: () => void;
}

export const DownloadCsvButton: React.FC<Props> = ({ additionalActions, onDownloadCsv }) => {
  const apiRef = useGridApiContext();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const handleDownload = () => {
    if (onDownloadCsv) {
      onDownloadCsv();
      return;
    }
    const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);

    apiRef.current.exportDataAsCsv({
      utf8WithBom: true,
      getRowsToExport: () => filteredSortedRowIds,
    });
  };

  if (!additionalActions?.length) {
    return (
      <Button
        size="small"
        variant="contained"
        color="primary"
        startIcon={<DownloadRoundedIcon />}
        onClick={handleDownload}
      >
        Download CSV
      </Button>
    );
  }

  return (
    <>
      <Button
        size="small"
        variant="text"
        color="inherit"
        endIcon={<ExpandMoreIcon />}
        startIcon={<DownloadRoundedIcon />}
        aria-haspopup="menu"
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        Export
      </Button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        <MenuItem
          onClick={() => {
            setAnchor(null);
            handleDownload();
          }}
        >
          <DownloadRoundedIcon fontSize="small" sx={{ mr: 1 }} />
          Download CSV
        </MenuItem>
        {additionalActions.map(({ label, icon, onClick }) => (
          <MenuItem
            key={label}
            onClick={() => {
              setAnchor(null);
              onClick();
            }}
          >
            {icon}
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
